import { LayoutGrid } from 'lucide-react';
import { createElement } from 'react';

import type { KhaiBaoModule } from '../../lib/modules.js';
import { TrangCanhBao } from './pages/TrangCanhBao.js';
import { TrangTongQuan } from './pages/TrangTongQuan.js';

/**
 * Module 11 — Tổng quan. Nhận route `/` (trước đây là chỗ giữ sẵn của module 00).
 *
 * Route `/` **không** khai `permission`: vai trò Cộng tác viên không có
 * `dashboard:view`, nếu chặn ở đây thì vừa đăng nhập đã gặp trang "Không đủ
 * quyền". Trang tự kiểm tra quyền rồi chuyển sang mục menu đầu tiên xem được.
 */
const dashboard: KhaiBaoModule = {
  id: 'dashboard',
  nav: {
    group: 'VẬN HÀNH',
    label: 'Tổng quan',
    icon: LayoutGrid,
    order: 1,
    permission: 'dashboard',
    to: '/',
  },
  routes: [
    { path: '/', element: createElement(TrangTongQuan) },
    {
      path: '/canh-bao',
      element: createElement(TrangCanhBao),
      permission: { module: 'dashboard', level: 'view' },
    },
  ],
};

export default dashboard;
